module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAARCAMAAAD9uOxFAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA5UExURcTExMTExMLCwsTExMTExMTExMTExMTExEdwTMTExMPDw8TExMTExMPDw8TExMPDw8PDw729vcXFxZBUFiAAAAASdFJOU/mUJbqmzuKRAJs8woFQ83FjD4Jc/SsAAACzSURBVCjPjZHbEsMgCEQVUVfBW/7/Y0vaJNMXO903PAPCriNxWwk56T5v5Lu4o2Ar7u7w8CkRpIInVDEZTUApZRR34sllQQmjojXUAVKswu3CW32wxhgzKoPCWoHAFXli6IVHCGGgZlBZqxB8hTZI/Dn8wWd3sKHWMieaop51j19/RzvMN4yBZmucD1H/2/x9d+Zbdjfb8g/OKZpr6Za5ltK8sPvtufSyS6xYYiR9F3cP9AK+8Q4s8Ql/FgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keyboard.png
// module id = oBfM
// module chunks = 1